import styled from '@emotion/styled';
import { Tag } from '@tajawal/ct-web-design-system';

const Wrapper = styled.div`
  display: flex;
  flex-shrink: 1;
  gap: 8px;
  height: 24px;
  & > .MuiDivider-root {
    margin: 0px 4px;
    min-height: 20px;
    width: 1px;
    height: 100%;
  }
`;

const SortTag = styled(Tag)`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
`;

export default {
  Wrapper,
  SortTag,
};
